import LoadingIcon from '../../assets/LoadingIcon'

function UpdateButton({ isLoading, onClick }) {
  return (
    <button
      className="btn btnPrimary dFlex aiCenter gap-2"
      onClick={onClick}
      disabled={isLoading}
    >
      {isLoading ? (
        <>
          <LoadingIcon />
          <span>Updating...</span>
        </>
      ) : (
        <span>Update</span>
      )}
    </button>
  )
}

export default UpdateButton
